const ProductCol = [
    'category_name',
    'is_active', 
    // 'actions'
    'id'
];

export default ProductCol;
